/**
 * 教室詳細モーダルをクリックした場合に閲覧済みラベルを表示する
 */
$(function () {
    // sessionStorageに保存する閲覧済みIDのキー名
    const storageKey = 'jyukunavi.viewedKoushaIds';

    /**
     * sessionStorageから閲覧済みID一覧を取得
     *
     * @returns {Array}
     */
    function getList() {
        try {
            return JSON.parse(sessionStorage.getItem(storageKey)) || [];
        } catch (e) {
            return [];
        }
    }

    /**
     * sessionStorageへ閲覧済みID一覧を保存
     *
     * @param {Array} list
     */
    function saveList(list) {
        try {
            sessionStorage.setItem(storageKey, JSON.stringify(list));
        } catch (e) {}
    }

    /**
     * 閲覧済みIDを保存
     *
     * @param {String|Number} id
     */
    function markViewed(id) {
        if (!id) return;

        id = String(id);
        const list = getList();

        if ($.inArray(id, list) === -1) {
            list.push(id);
            saveList(list);
        }
    }

    /**
     * 閲覧済みアイコンを表示
     */
    function showIcons() {
        const viewedIds = getList();

        $('.js-school-list').each(function () {
            const $item = $(this);
            const id = String($item.data('kousha-or-tutor-id') || '');
            $item.find('.js-viewed-icon').toggle(
                id && $.inArray(id, viewedIds) !== -1
            );
        });
    }

    // 初期表示
    showIcons();

    /**
     * 教室詳細モーダルクリック時
     */
    $(document).on(
        'click',
        '.js-lp-modal-window-btn-iframe',
        function () {

            const $item = $(this).parents('.js-school-list');
            const id = $item.data('kousha-or-tutor-id');

            if (!id) return;

            markViewed(id);
            $item.find('.js-viewed-icon').show();
        }
    );

    // ブランド（1教室）クリックで閲覧済をマーク
    $(document).on('click', '.js-kousha-modal-lp-area-click-brand-box', function () {
        const $el = $(this);
        let id = '';

        if ($el.attr('tutor_id')) {
            id = 't' + $el.attr('tutor_id'); // tutor は 't' プレフィックス
        } else if ($el.attr('kousha_id')) {
            id = String($el.attr('kousha_id'));
        } else if ($el.attr('juku_id') && $el.data('kousha-id')) {
            id = String($el.data('kousha-id'));
        }
        if (!id) return;

        // 既存関数が同ファイル内にある想定：markViewed(id) と showIcons()
        if (typeof markViewed === 'function') {
            markViewed(id);
        } else {
            // フォールバック（既存関数がスコープ外なら同じロジックで保存）
            const storageKey = 'jyukunavi.viewedKoushaIds';
            try {
                const list = JSON.parse(sessionStorage.getItem(storageKey)) || [];
                if ($.inArray(id, list) === -1) {
                    list.push(id);
                    sessionStorage.setItem(storageKey, JSON.stringify(list));
                }
            } catch (e) {}
        }

        if (typeof showIcons === 'function') {
            showIcons();
        } else {
            // フォールバックで対象アイコンだけ即時表示
            $('.js-school-list').each(function () {
                const $item = $(this);
                const dataId = String($item.data('kousha-or-tutor-id') || '');
                if (dataId && dataId === id) {
                    $item.find('.js-viewed-icon').show();
                }
            });
        }
    });
});